import type { IWebHookFilterHistoric, IWebHookListHistoric } from 'v2/interfaces/webhook/historic';
import type { IWebHookFilter } from 'v2/interfaces/webhook/webhook';

import apiService from '../api';

import type { ApiService } from '../api';
import type IPagination from 'interfaces/IPagination';

export class WebHookService {
  constructor(private apiService: ApiService) {}

  public getList = (filters: IWebHookFilter) => {
    return this.apiService.get('/webhook/urls', { url: filters?.url, description: filters?.name, type: filters?.type });
  };

  public getListHistoric = (filters: IWebHookFilterHistoric, pagination: IPagination) => {
    return this.apiService.get('/webhook', {
      start_date: filters?.date[0],
      end_date: filters?.date[1],
      entity_id: filters?.invoice,
      content_ids: filters?.product,
      client_name: filters?.customer,
      url: filters?.url,
      per_page: pagination?.per_page,
      page: pagination?.current_page,
      type: filters?.type,
    });
  };

  public changeUrlStatus = (id: string, status: boolean) => {
    return this.apiService.put(`/webhook/urls/${id}/status`, { status });
  };

  public removeWebhook = (id: string) => {
    return this.apiService.delete(`/webhook/urls/${id}`, {});
  };

  public testWebHook = (type: string, status: number, url: string) => {
    return this.apiService.post('/webhook/test', { status, type, url });
  };

  public getProducts = () => {
    return this.apiService.get('/webhook/products');
  };

  public createURL = (name: string, product: number, url: string, type: string) => {
    return this.apiService.post('/webhook/urls', { description: name, product_id: product, url, type });
  };

  public editURL = (id: string, name: string, product: number, url: string) => {
    return this.apiService.put(`/webhook/urls/${id}`, { description: name, product_id: product, url });
  };

  public resendURL = (webhook: IWebHookListHistoric) => {
    return this.apiService.post(`/webhook/${webhook.payloadId}/send`, { url: webhook.url });
  };

  public getHistoricWebhook = (webhook: IWebHookListHistoric) => {
    return this.apiService.get(`/webhook/${webhook.payloadId}/send`, { url: encodeURIComponent(webhook.url) });
  };
}

const webhookService = new WebHookService(apiService);
export default webhookService;
